import { FaLaptopCode, FaMobileAlt, FaShoppingCart, FaDatabase, FaSearch, FaBullhorn, FaPaintBrush, FaChartLine, FaTools, FaRocket, FaIndustry, FaHospitalSymbol, FaGraduationCap, FaHotel, FaTruckMoving, FaUtensils, FaCloud } from "react-icons/fa";
import {  MdSecurity } from "react-icons/md";
import { SiGoogleanalytics, SiAdobeindesign } from "react-icons/si";

const services = [
  {
    category: "Software & Web Development",
    items: [
      {
        title: "Custom Software Development",
        description: "Bespoke software solutions architected to solve your unique business challenges.",
        icon: FaLaptopCode,
        color: "#4f46e5"
      },
      {
        title: "Web & Mobile App Development",
        description: "High-performance, responsive, and scalable applications for all major platforms.",
        icon: FaMobileAlt,
        color: "#16a34a"
      },
      {
        title: "E-commerce & Marketplace Platforms",
        description: "Feature-rich online stores and multi-vendor marketplaces with secure payment gateways.",
        icon: FaShoppingCart,
        color: "#f97316"
      },
      {
        title: "UI/UX Design & Prototyping",
        description: "Intuitive and engaging user interfaces designed to maximize user satisfaction and conversion.",
        icon: SiAdobeindesign,
        color: "#e11d48"
      },
      {
        title: "API Development & Integration",
        description: "Robust APIs and seamless third-party integrations to connect your software ecosystem.",
        icon: FaDatabase,
        color: "#0ea5e9"
      }
    ]
  },
  {
    category: "Digital Marketing & Branding",
    items: [
      {
        title: "Search Engine Optimization (SEO)",
        description: "Comprehensive SEO strategies to improve organic rankings and drive targeted traffic.",
        icon: FaSearch,
        color: "#facc15"
      },
      {
        title: "Search Engine Marketing (SEM/PPC)",
        description: "Drive immediate traffic and leads with targeted Pay-Per-Click campaigns on Google and Bing.",
        icon: FaChartLine,
        color: "#22c55e"
      },
      {
        title: "Social Media & Content Marketing",
        description: "Engaging content strategies and social media campaigns to build your brand and community.",
        icon: FaBullhorn,
        color: "#ec4899"
      },
      {
        title: "Data & Web Analytics",
        description: "Actionable insights from data to understand user behavior and optimize marketing ROI.",
        icon: SiGoogleanalytics,
        color: "#f59e0b"
      },
      {
        title: "Brand Identity & Graphic Design",
        description: "Memorable branding and compelling visual designs that tell your story.",
        icon: FaPaintBrush,
        color: "#dc2626"
      }
    ]
  },
  {
    category: "Cloud, Maintenance & Support",
    items: [
      {
        title: "Cloud Strategy & Migration",
        description: "Expert guidance on cloud adoption, migration, and infrastructure management (AWS, Azure, GCP).",
        icon: FaCloud,
        color: "#3b82f6"
      },
      {
        title: "Application Maintenance & Support",
        description: "Proactive maintenance to ensure your digital assets are secure, updated, and efficient.",
        icon: FaTools,
        color: "#475569"
      },
      {
        title: "Performance Optimization",
        description: "Enhancing speed, reliability, and user experience through continuous performance tuning.",
        icon: FaRocket,
        color: "#14b8a6"
      },
      {
        title: "IT Security & Audits",
        description: "Comprehensive security audits and consulting to protect your applications and data.",
        icon: MdSecurity,
        color: "#6d28d9"
      }
    ]
  },
  {
    category: "Industry-Specific Solutions",
    items: [
      {
        title: "Healthcare Solutions",
        description: "Digital tools for clinics, hospitals, and telemedicine.",
        icon: FaHospitalSymbol,
        color: "#ef4444"
      },
      {
        title: "EdTech Platforms",
        description: "E-learning platforms and school management systems.",
        icon: FaGraduationCap,
        color: "#2563eb"
      },
      {
        title: "Real Estate Solutions",
        description: "Property listing, booking, and CRM tools.",
        icon: FaIndustry,
        color: "#f97316"
      },
      {
        title: "Travel & Hospitality Solutions",
        description: "Booking systems for tours, hotels, and transport.",
        icon: FaHotel,
        color: "#0d9488"
      },
      {
        title: "Restaurant & Food Delivery",
        description: "POS systems and online ordering platforms.",
        icon: FaUtensils,
        color: "#b91c1c"
      },
      {
        title: "Logistics & Transport",
        description: "Fleet management and delivery tracking solutions.",
        icon: FaTruckMoving,
        color: "#9333ea"
      }
    ]
  }
];

export default services;